module.exports = __webpack_public_path__ + "static/media/down-arrow.3e4771de.svg";